import { PredictiveDriveTimeReportRows } from '@/models/gen/graphql';
import Table from '@/common/Table';
import { TableRowProps } from '@/common/Table/TableRow';

export type TimeIntervalRowProps = {
  data: PredictiveDriveTimeReportRows;
} & TableRowProps;

const TimeIntervalRow = ({ data, ...props }: TimeIntervalRowProps): JSX.Element => {
  return (
    <Table.Row {...props} className="TimeIntervalRow">
      <Table.Cell className="PeriodCell">{data?.period ?? '--'}</Table.Cell>
      <Table.Cell className="TimeFrameCell">{data?.timeFrame ?? '--'}</Table.Cell>
      <Table.Cell className="WeekdayAvgCell" data-suffix=" min" data-placeholder="--">
        {data?.weekdayAvg ?? '0'}
      </Table.Cell>
      <Table.Cell className="WeekendAvgCell" data-suffix=" min" data-placeholder="--">
        {data?.weekendAvg ?? '0'}
      </Table.Cell>
      <Table.Cell className="MinutesCell">{data?.p60 ?? '0'}</Table.Cell>
      <Table.Cell className="MinutesCell">{data?.p80 ?? '0'}</Table.Cell>
      <Table.Cell className="MinutesCell">{data?.p90 ?? '0'}</Table.Cell>
      <Table.Cell className="MinutesCell">{data?.p95 ?? '0'}</Table.Cell>
      <Table.Cell className="MinutesCell">{data?.p99 ?? '0'}</Table.Cell>
    </Table.Row>
  );
};

export default TimeIntervalRow;
